"use client";

import { SessionProvider } from "next-auth/react";
import { ClueClient, ClueClientProps } from "./ClueClient";

/**
 * Props for the ClueWrapper component.
 * Extends ClueClientProps to maintain type consistency.
 */
export type ClueWrapperProps = ClueClientProps;

/**
 * Wrapper component that provides SessionProvider context for ClueClient.
 *
 * This component is used by page components to wrap the ClueClient
 * with the necessary Next-Auth session context.
 *
 * Usage:
 * ```tsx
 * // In your page.tsx
 * <ClueWrapper
 *   clue={clue}
 *   campaign={campaign}
 *   tenant={tenant}
 *   navigation={navigation}
 *   searchParams={searchParams}
 *   routePattern="standard" // or "legacy"
 * />
 * ```
 */
export function ClueWrapper(props: ClueWrapperProps) {
  return (
    <SessionProvider>
      <ClueClient {...props} />
    </SessionProvider>
  );
}
